module.exports = __webpack_public_path__ + "img/25.0e8ed600.png";